import { render, staticRenderFns } from "./sheba.vue?vue&type=template&id=61487ff6&scoped=true&"
import script from "./sheba.vue?vue&type=script&lang=js&"
export * from "./sheba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61487ff6",
  null
  
)

export default component.exports